import { render, staticRenderFns } from "./OrganizationDashboard.vue?vue&type=template&id=11a4b10e&"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=js&"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationDashboard.vue?vue&type=style&index=0&id=11a4b10e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports